import axios from 'axios';

export default {
  checkAuth (path) {
    let userToken = localStorage.getItem('token')
    if (!userToken && path != '/login') {
      return false
    }

    let expiredToken = localStorage.getItem('expired')
    let isExpired = false

    if (new Date() > new Date(expiredToken) && path != '/login') {
      return false
    } else {
      isExpired = false
    }

    if (!isExpired) {
      return this.checkToken()
    }
  },

  async checkToken () {
    try {
        let token = localStorage.getItem('token')
        const response = await axios.get(`/auth/auth?token=${token}`)

        if(response.status = 200) {
          return response.data.user_id
        } else {
          return false
        }

    } catch (err) {
        console.log(err)
        return false
    }
  }
}